module.exports = __webpack_public_path__ + "assets/img/ddbes_t.463a1abc.png";